export default "__VITE_ASSET__f7cc0381__"